import { useTranslation } from 'react-i18next'
import { ExclamationMark } from '@/assets/icons/ExclamationMark'
import { useAppSelector } from '@/hooks/store'
import { mapPageErrorsSelector } from '@/store/cartSlice/selectors/mapPageErrorsSelector'
import { ticketSlice } from '@/store/ticketSlice'

export function SetupCartActionsMapErrors() {
  const { t } = useTranslation()

  const mapErrors = useAppSelector(mapPageErrorsSelector)
  const submitted = useAppSelector(ticketSlice.selectors.submitted)

  if (!submitted || mapErrors.length === 0) {
    return null
  }

  return (
    <div className="mt-4 flex items-center gap-1 rounded border border-red-600 bg-red-50 p-1">
      <ExclamationMark className="size-5 shrink-0 text-red-600" />
      <div className="space-y-1">
        {mapErrors.map((err, index) => {
          if (err.type === 'minQty') {
            return (
              <div className="text-sm" key={index}>
                {t(`ticketErrorsWithServiceName.${err.type}`, {
                  min: err.minQty,
                  serviceName: err.serviceName,
                })}
              </div>
            )
          }

          if (err.type === 'maxQty') {
            return (
              <div className="text-sm" key={index}>
                {t(`ticketErrorsWithServiceName.${err.type}`, {
                  max: err.maxQty,
                  serviceName: err.serviceName,
                })}
              </div>
            )
          }

          return null
        })}
      </div>
    </div>
  )
}
